module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-gray-b455f055dc2b29bdf16455f9017965db.png";